import React from "react";
import "../../styles/Styles.css";

function Allergens() {
    return (
        <div className="container pb-5 mb-5">
            <p className="fs-3">Alergeny</p>
            <hr />
            <p>*1 - Gluten, *2 - Skorupiaki, *3 - Jaja i produkty pochodne, *4 -Ryby i produkty pochodne, *5 Orzeszki ziemnie (arachidowe), *6 - Soja i produkty pochodne, *7 - Mleko i produkty pochodne, *8 - Orzechy, *9 - Seler i produkty pochodne, *10 - Gorczyca, *11 - Nasiona sezamu, *12 - Dwutlenek siarki, *13 - Łubin, *14 - Mięczaki i produkty pochodne
            </p>
        </div>
    )
}

export default Allergens;